



















import {
  Vue, Component, Prop, Mixins, PropSync, Watch,
} from 'vue-property-decorator';
import { Doughnut } from 'vue-chartjs';
import Chart from 'chart.js';
import ChartsUtil from '@/util/ChartUtils';
import StatsUtil from '@/util/StatsUtil';

@Component({})
export default class SectorStats extends Mixins(Doughnut) {
  @PropSync('sectorLists', {}) sectorList!: any;

  @PropSync('marketSelected', {}) selectedMarket!: any;

  private chart: any;

  mounted() {
    this.generateChart(this.sectorList);
  }

  public generateChart(conf: any) {
    const ctx: any = document.getElementById('planet-chart');
    const sectorLegendContainer = (this.$refs.sectorLegend as any);
    const sectorNoDataContainer = (this.$refs.sectorNoData as any);
    if (ctx) {
      if (!conf) {
        const config = this.getChartConfig(this.sectorList);
        if (this.chart) {
          this.chart.data.datasets = config.datasets;
          this.chart.data.labels = config.chartLabels;
        } else {
          const chartConfig = ChartsUtil.generateChartData(config.chartLabels,
            config.datasets);
          this.chart = new Chart(
            ctx,
            chartConfig,
          );
          this.chart.options.animation = ChartsUtil
            .getChartAnimation(sectorNoDataContainer, sectorLegendContainer);
        }
      } else {
        const chartConfig = this.getChartConfig(conf);
        if (this.chart) {
          this.chart.data.datasets = chartConfig.datasets;
          this.chart.data.labels = chartConfig.chartLabels;
        } else {
          this.chart = new Chart(
            ctx,
            ChartsUtil.generateChartData(chartConfig.chartLabels,
              chartConfig.datasets),
          );
          this.chart.options.animation = ChartsUtil
            .getChartAnimation(sectorNoDataContainer, sectorLegendContainer);
        }
      }

      const myLegendContainer: any = document.getElementById('legend');
      myLegendContainer.innerHTML = this.chart.generateLegend();
      this.chart.update();
    }
  }

  public getChartConfig(list: any) {
    const { data } = list;
    const chartData = data.datasets[0]?.data;
    const chartLabels = data.labels;
    const datasets = [
      {
        backgroundColor: [
          '#5eba60',
          '#f284b1',
          '#f2634b',
          '#0d4fb2',
          '#fba708',
          '#5ba4de',
          '#29902b',
          '#b3386a',
          '#ec2807',
          '#0068ff',
          '#bb7c06',
          '#ff0099',
          '#c000ff',
          '#00b8ff',
          '#00f3ff',
          '#56ff00',

        ],
        data: chartData,
      },
    ];
    return {
      chartLabels,
      datasets,
    };
  }

  @Watch('sectorLists')
  async checkSectorList(val: any) {
    this.generateChart(val);
  }
}
